import { render } from "./HeroiconsOutlineColorSwatch.vue?vue&type=template&id=3628d9ac"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineColorSwatch.vue"]])

export default __exports__